// extracted by mini-css-extract-plugin
module.exports = {"assets":"Assets_assets__16w4t"};